import Image from 'next/image';
import Link from 'next/link';

const ctaTiles = [
  {
    title: 'Are you a gym/studio owner? Get in touch to create or claim a listing.',
    buttonText: 'Create/Claim Listing',
    image: '/cta-owner.jpg',
    href: '/claim-listing',
  },
  {
    title: 'Are you a female personal trainer? Secure your spot now & join our listing website.',
    buttonText: 'Join Now',
    image: '/cta-trainer.jpg',
    href: '/join-as-trainer',
  },
];

const CTATiles = () => {
  return (
    <section className="py-20 bg-[#f5f2f0]">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-6">
          {ctaTiles.map((tile, index) => (
            <div
              key={index}
              className="relative h-[280px] rounded-[20px] overflow-hidden group"
            >
              {/* Background Image */}
              <Image
                src={tile.image}
                alt={tile.title}
                fill
                className="object-cover"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-[#45394B]/70" />

              {/* Content */}
              <div className="absolute inset-0 p-8 flex flex-col justify-between">
                <h3 className="text-2xl font-bold text-white leading-tight">
                  {tile.title}
                </h3>
                <Link
                  href={tile.href}
                  className="inline-flex items-center px-6 py-3 bg-white/20 backdrop-blur-sm text-white font-medium rounded-xl hover:bg-white/30 transition-colors w-fit"
                >
                  {tile.buttonText}
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CTATiles;
